@if (data) {
  <div class="font-poppins text-gray-800">
    <h3 class="text-lg font-bold mb-1"> Found SOA Tables on the following pages: </h3>
    @for(page of data.pages; track page) {
      <p class="text-gray-700 font-mono break-words whitespace-pre-line max-w-full">- Page {{page}}</p>
      <!-- <div [innerHTML]="data.tables[page]"></div> -->
    }
  </div>
}